/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaypalPaymentSource } from './PaypalPaymentSource';
import {
    PaypalPaymentSourceFromJSON,
    PaypalPaymentSourceFromJSONTyped,
    PaypalPaymentSourceToJSON,
} from './PaypalPaymentSource';

/**
 * 
 * @export
 * @interface PaypalPaymentProcessor
 */
export interface PaypalPaymentProcessor {
    /**
     * 
     * @type {PaypalPaymentSource}
     * @memberof PaypalPaymentProcessor
     */
    id?: PaypalPaymentSource;
    /**
     * 
     * @type {string}
     * @memberof PaypalPaymentProcessor
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PaypalPaymentProcessor
     */
    cardHolder?: string;
    /**
     * 
     * @type {string}
     * @memberof PaypalPaymentProcessor
     */
    cardNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PaypalPaymentProcessor
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PaypalPaymentProcessor
     */
    cvv?: string;
}

/**
 * Check if a given object implements the PaypalPaymentProcessor interface.
 */
export function instanceOfPaypalPaymentProcessor(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaypalPaymentProcessorFromJSON(json: any): PaypalPaymentProcessor {
    return PaypalPaymentProcessorFromJSONTyped(json, false);
}

export function PaypalPaymentProcessorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaypalPaymentProcessor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : PaypalPaymentSourceFromJSON(json['id']),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'cardHolder': !exists(json, 'cardHolder') ? undefined : json['cardHolder'],
        'cardNumber': !exists(json, 'cardNumber') ? undefined : json['cardNumber'],
        'expirationDate': !exists(json, 'expirationDate') ? undefined : json['expirationDate'],
        'cvv': !exists(json, 'cvv') ? undefined : json['cvv'],
    };
}

export function PaypalPaymentProcessorToJSON(value?: PaypalPaymentProcessor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': PaypalPaymentSourceToJSON(value.id),
        'email': value.email,
        'cardHolder': value.cardHolder,
        'cardNumber': value.cardNumber,
        'expirationDate': value.expirationDate,
        'cvv': value.cvv,
    };
}

